// services/customerLoginService.js

import API_BASE from "../config/api";

export const customerLogin = async ({ username, password }) => {

  const response = await fetch(`${API_BASE}/Customer/SignIn`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ username, password }),
  });

  const data = await response.json();

  if (!response.ok || data.status !== 0) {
    throw new Error(data?.message || "Login failed");
  }

  return data;
};